<pages-container [title]="'certificate.title'" [icon]="'workspace_premium'">
  <div buttons>
    <button mat-raised-button class="mat-white-bg" [routerLink]="['/pages/certificate/new']">
      {{ 'certificate.add' | translate }}
    </button>
  </div>
  <div main-content>
    <div class="templates">
      @for(template of templates(); track template.id) {
        <div class="template" (click)="openTemplate(template.id)">
          <div class="template-name">{{template.name}}</div>
          @if (getPreviewUrl(template.id); as previewUrl) {
            <img class="template-preview" [src]="previewUrl" [alt]="template.name" />
          } @else {
            <div class="template-preview template-preview-placeholder" aria-hidden="true">
              <mat-icon>workspace_premium</mat-icon>
            </div>
          }
        </div>
      }
    </div>
  </div>
</pages-container>
